import { TFunction } from "i18next";
import { z } from "zod";

export const getGodAviFormSchema = (t: TFunction) => {
  return z.object({
    godGId: z
      .number({
        required_error: t("calculations.vulnerability.god-avi.errors.god-g-required"),
        invalid_type_error: t("calculations.vulnerability.god-avi.errors.god-g-required"),
      }),
    godOId: z
      .number({
        required_error: t("calculations.vulnerability.god-avi.errors.god-o-required"),
        invalid_type_error: t("calculations.vulnerability.god-avi.errors.god-o-required"),
      }),
    godDId: z
      .number({
        required_error: t("calculations.vulnerability.god-avi.errors.god-d-required"),
        invalid_type_error: t("calculations.vulnerability.god-avi.errors.god-d-required"),
      }),
  });
};

export type GodAviForm = z.infer<ReturnType<typeof getGodAviFormSchema>>;